export default "__VITE_ASSET__46a07a9d__"